import React, { useState } from "react";
import { useLocation } from "react-router-dom"; // Step 1
import SideBar from "../../components/Sidebar";

const ServicesBox = () => {
  const [showModal, setShowModal] = useState(false);
  const location = useLocation(); // Step 2

  const services = [
    {
      name: "Mobile",
      href: "/mobile-recharge",
      icon: "/assets/images/mobile-icon.png",
    },
    {
      name: "DTH",
      href: "/dth-recharge",
      icon: "/assets/images/dish-tv-icon.png",
    },
    // {
    //   name: "FasTag",
    //   href: "/bill-payment/Fastag",
    //   icon: "/assets/images/fastag-logo.png",
    // },
    {
      name: "Google Play",
      href: "/google-play-redeem-code",
      icon: "/assets/images/google-play-logo.png",
    },
    // {
    //   name: "Postpaid",
    //   href: "/bill-payment/Postpaid",
    //   icon: "/assets/images/postpaid-icon.png",
    // },
    // // {
    // //   name: "Credit Card",
    // //   href: "/bill-payment/Credit Card",
    // //   icon: "/assets/images/credit-card-icon.png",
    // // },
    // {
    //   name: "Loan/EMI",
    //   href: "/bill-payment/Loan%20Repayment",
    //   icon: "/assets/images/loan-payment-icon.png",
    // },
    // {
    //   name: "Electricity",
    //   href: "/bill-payment/Electricity",
    //   icon: "/assets/images/electricity-bill-icon.png",
    // },
    // {
    //   name: "Landline",
    //   href: "/bill-payment/Landline",
    //   icon: "/assets/images/landline-icon.png",
    // },
    // {
    //   name: "Broadband",
    //   href: "/bill-payment/Broadband",
    //   icon: "/assets/images/broadband-icon.png",
    // },
    // // {
    // //   name: "Insurance",
    // //   href: "/bill-payment/Insurance",
    // //   icon: "/assets/images/insurance-icon.png",
    // // },
    // {
    //   name: "Cable TV",
    //   href: "/bill-payment/Cable%20TV",
    //   icon: "/assets/images/cable-tv-icon.png",
    // },
    // {
    //   name: "Book Cylinder",
    //   href: "/bill-payment/LPG%20Booking",
    //   icon: "/assets/images/gas-cylinder-icon.png",
    // },
    // {
    //   name: "Piped Gas",
    //   href: "/bill-payment/Gas",
    //   icon: "/assets/images/gas-pipeline-icon.png",
    // },
    // {
    //   name: "Water",
    //   href: "/bill-payment/Water",
    //   icon: "/assets/images/water-bill-icon.png",
    // },
  ];

  const visibleServices = services.slice(0, 9);
  const hiddenServices = services.slice(9);

  return (
    <>
      <div className="container my-4">
        <div className="d-flex gap-3 pb-2 d-flex justify-content-center">
          {visibleServices.map((service, index) => {
            const isActive = location.pathname === service.href; // Step 3
            return (
              <a
                href={service.href}
                key={index}
                className="text-decoration-none flex-shrink-0"
                style={{ width: "100px" }}
              >
                <div
                  className={`border rounded p-2 text-center shadow-sm hover-effect ${
                    isActive ? "bg-primary text-white" : ""
                  }`}
                >
                  <div
                    className={`mx-auto d-flex align-items-center justify-content-center rounded-circle ${
                      isActive ? "bg-white" : "bg-light"
                    }`}
                    style={{ width: "60px", height: "60px" }}
                  >
                    <img
                      src={service.icon}
                      alt={service.name}
                      width="30"
                      height="30"
                    />
                  </div>
                  <div
                    className="fw-medium small mt-2"
                    style={{ fontSize: "13px" }}
                  >
                    {service.name}
                  </div>
                </div>
              </a>
            );
          })}

          {/* More Button */}
          <div
            onClick={() => setShowModal(true)}
            className="text-decoration-none flex-shrink-0"
            style={{ width: "100px", cursor: "pointer" }}
          >
            <div className="border rounded p-2 text-center shadow-sm hover-effect">
              <div
                className="mx-auto d-flex align-items-center justify-content-center rounded-circle bg-light"
                style={{ width: "60px", height: "60px" }}
              >
                <span className="fw-bold" style={{ fontSize: "20px" }}>
                  +
                </span>
              </div>
              <div
                className="fw-medium small mt-2"
                style={{ fontSize: "13px" }}
              >
                More
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for more services */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          onClick={() => setShowModal(false)}
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div
            className="modal-dialog modal-bottom"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content rounded-top">
              <div className="modal-header">
                <h5 className="modal-title">More Services</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row row-cols-3 g-3">
                  {hiddenServices.map((service, index) => {
                    const isActive = location.pathname === service.href;
                    return (
                      <a
                        href={service.href}
                        key={index}
                        className="text-decoration-none text-center"
                      >
                        <div
                          className={`border rounded p-2 h-100 shadow-sm hover-effect ${
                            isActive ? "bg-primary text-white" : ""
                          }`}
                        >
                          <div
                            className={`mx-auto d-flex align-items-center justify-content-center rounded-circle ${
                              isActive ? "bg-white" : "bg-light"
                            } mb-2`}
                            style={{ width: "60px", height: "60px" }}
                          >
                            <img
                              src={service.icon}
                              alt={service.name}
                              width="30"
                              height="30"
                            />
                          </div>
                          <div className="fw-medium small">{service.name}</div>
                        </div>
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ServicesBox;
